"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalBigVideoNews(t0) {
  const $ = _c(24);
  const {
    title: t1,
    excerpt: t2,
    timeAgo: t3,
    imageSrc: t4,
    slug,
    imageMetadata
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {
      hidden: false,
      value: "'\u0B95\u0B9F\u0BBF\u0BA9 \u0B95\u0BA4\u0BCB\u0BB0\u0BBF \u0B85\u0BA3\u0BCD\u0B9F\u0B95\u0B9F\u0BB9\u0BAE\u0BCD' \u0BA4\u0BBF\u0BB0\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F \u0BB5\u0BBF\u0BAE\u0BB0\u0BCD\u0B9A\u0BA9\u0BAE\u0BCD: \u0BB5\u0BC6\u0B95\u0BC1 \u0BA4\u0BCA\u0BA9\u0BB2\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD \u0B87\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B95\u0B9F\u0BA8\u0BCD\u0BA4 \u0B95\u0BBE\u0BB2\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BBF\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B89\u0BA3\u0BB0\u0BCD\u0B9A\u0BCD\u0B9A\u0BBF\u0BAF\u0BC8",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const title = t5;
  t2 === undefined ? {
    hidden: false,
    value: "\u0BA8\u0BBE\u0B9F\u0BCD\u0B9F\u0BBF\u0BA9\u0BCD \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B89\u0BB1\u0BCD\u0BAA\u0BA4\u0BCD\u0BA4\u0BBF 2023 \u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BBF\u0BB2\u0BCD 8.5 \u0B9A\u0BA4\u0BB5\u0BC0\u0BA4\u0BAE\u0BCD \u0B85\u0BA4\u0BBF\u0B95\u0BB0\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 7.314 \u0B95\u0BCB\u0B9F\u0BBF \u0B9F\u0BA9\u0BCD\u0BA9\u0BBE\u0B95",
    customClass: ""
  } : t2;
  t3 === undefined ? {
    hidden: false,
    value: "15 min ago",
    customClass: ""
  } : t3;
  let t6;
  if ($[2] !== t4) {
    t6 = t4 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t4;
    $[2] = t4;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const imageSrc = t6;
  const titleValue = title?.value || "";
  let t7;
  if ($[4] !== imageSrc?.value) {
    t7 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[4] = imageSrc?.value;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const imageSrcValue = t7;
  let t8;
  if ($[6] !== imageMetadata || $[7] !== imageSrc?.customClass || $[8] !== imageSrc?.hidden || $[9] !== imageSrcValue || $[10] !== titleValue) {
    t8 = !imageSrc?.hidden && <div className={`w-full md:w-5/12 lg:w-2/5 shrink-0 ${imageSrc?.customClass || ""}`}><div className="relative w-full min-h-[230px] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} className="object-cover w-full h-full" style={getFocusPointStyle(imageMetadata)} sizes="(max-width: 768px) 100vw, 40vw" loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[6] = imageMetadata;
    $[7] = imageSrc?.customClass;
    $[8] = imageSrc?.hidden;
    $[9] = imageSrcValue;
    $[10] = titleValue;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== title?.customClass || $[13] !== title?.hidden || $[14] !== titleValue) {
    t9 = !title?.hidden && <h3 className={`text-24-tamil-700 md:text-14text-12-tamil-400 text-FFFFFF leading-[1.6] -tamil-700 text-012061 font-medium leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[12] = title?.customClass;
    $[13] = title?.hidden;
    $[14] = titleValue;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <div className="flex flex-col justify-between lg:min-h-[230px] w-full"><div className="flex flex-col gap-3">{t9}</div></div>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8) {
    t11 = <article className="bg-F8F8F8 overflow-hidden p-4 mb-0"><div className="flex flex-col md:flex-row gap-4">{t8}{t10}</div></article>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const content = t11;
  if (slug) {
    const t12 = `/${slug}`;
    let t13;
    if ($[21] !== content || $[22] !== t12) {
      t13 = <Link href={t12} className="block hover:bg-gray-100 transition-colors cursor-pointer">{content}</Link>;
      $[21] = content;
      $[22] = t12;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    return t13;
  }
  return content;
}